import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import PropertySubtype from './property_subtype';

export default function CompanyGridPropertySubtypes({ propertyType, onChange }) {
  const subtypes = Object.values(propertyType.subtypesById);

  return (
    <div className={classNames('property-subtypes', { long: subtypes.length > 8 })}>
      {Object.values(propertyType.subtypesById).map(subtype => (
        <PropertySubtype
          key={subtype.id}
          subtype={subtype}
          onChange={onChange}
        />
      ))}
    </div>
  );
}

CompanyGridPropertySubtypes.propTypes = {
  propertyType: PropTypes.shape({
    subtypesById: PropTypes.objectOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    })).isRequired,
  }).isRequired,
  onChange: PropTypes.func,
};
